var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav",style:({ width: _vm.sidebar.opened ? 'calc(100vw - 200px)' : 'calc(100vw - 54px)' })},[(_vm.favTopShow)?_c('fav-top-menu'):_vm._e(),_c('tags-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }